import React from "react";
import { Helmet } from "react-helmet-async";
import Layout from "../../../components/Layout/layout";
import UrlManagerPage from "../../../components/Superadmin/urlManager";
import { HeaderType } from "../../../components/Layout/header";
import ProtectedRoute from "../../../../Auth/components/ProtectedRoute";

const UrlManager = () => (
  <ProtectedRoute>
    <main>
    <Helmet title="URL Manager" />
    <Layout headerType={HeaderType.superadmin}>
      <UrlManagerPage />
    </Layout>
    </main>
  </ProtectedRoute>
);

export default UrlManager;
